/// <reference path="../../../../typings/tsd.d.ts" /> 

module warsApp.models {
    export class MapConfigurationOverridesModel {
        public overrides: Wars.Domain.Model.Gis.MapConfigurationOverride[];
        public currentOverride: Wars.Domain.Model.Gis.MapConfigurationOverride;
        public selectedMapConfiguration: Wars.Domain.Model.Gis.MapConfiguration;
        public selectedWorkflow: Wars.Domain.Model.Gis.GisActionWorkflowConfiguration;
        public selectedMapFunction: Wars.Domain.Model.Gis.MapFunctionConfiguration;
        public selectedWorkflowOverride: Wars.Domain.Model.Gis.GisActionWorkflowOverride;
        public mapConfigurations: Wars.Domain.Model.Gis.MapConfiguration[];

        public sectionBindings: Array<any>;
        public metadataProperties: Array<any>;

        public isLastActionAddFeature:boolean;

        constructor(private mapConfigurationOverridesService: services.MapConfigurationOverridesService,
            private mapConfigurationService: services.MapConfigurationService,
            private formService: services.FormService,
            private deleteService:services.DeleteService,
            private processConfigurationId: string) {

            this.mapConfigurationService.getMapConfigurations().then(mapConfigurations => {
                this.mapConfigurations = mapConfigurations;
            });

            this.mapConfigurationOverridesService.getMapConfigurationOverrides(processConfigurationId).then(r => {
                this.overrides = r;
            });

            this.formService.getProcessConfigurationFormsWithSections(processConfigurationId).then(forms => {
                this.sectionBindings = [];

                forms.forEach(f => {
                    f.mySteps.forEach(step => {
                        step.formSections.forEach(section => {
                            this.sectionBindings.push({
                                name: f.name + ' Form , '+ section.objectSchema.name + ' Section ',
                                formSection: section
                            });
                        });
                    });
                });
            })

        }

        public addMapConfigurationOverrides() {
            let newOverride = this.mapConfigurationOverridesService.createMapConfigurationOverrides();

            newOverride.name = "New Override";
            newOverride.mapConfiguration = this.selectedMapConfiguration;
            newOverride.processConfiguration_id = this.processConfigurationId;

            this.overrides.push(newOverride);
            this.currentOverride = newOverride;

            this.save();
        }

        public deleteFunction(func: Wars.Domain.Model.Gis.IncludedMapFunction) {
            func.entityAspect.setDeleted();

            this.save();
        }

        public deleteFieldMap(fieldMap: Wars.Domain.Model.Gis.GisActionWorkflowGisFieldMap) {
            fieldMap.entityAspect.setDeleted();

            this.save();
        }

        public deleteWorkflowOverride(workflowOverride: Wars.Domain.Model.Gis.GisActionWorkflowOverride) {
            workflowOverride.entityAspect.setDeleted();

            this.save();
        }

        public addIncludedFunction() {
            this.currentIncludedFunction = this.mapConfigurationOverridesService.createIncludedMapFunction();
            this.currentIncludedFunction.mapFunctionConfiguration = this.selectedMapFunction;
            this.currentOverride.includedMapFunctions.push(this.currentIncludedFunction);

            this.save();
        }

        public addGisActionWorkflowOverride() {
            let newWorkflow = this.mapConfigurationOverridesService.createGisActionWorkflowOverride();
            newWorkflow.isAddReadOnly = false;

            newWorkflow.gisActionWorkflowConfiguration = this.selectedWorkflow;
            this.currentOverride.gisActionWorkflowOverrides.push(newWorkflow);

            this.save();
        }

        public addFieldMap() {
            let newFieldMap = this.mapConfigurationOverridesService.createGisActionWorkflowGisFieldMap();
            newFieldMap.metadataPosition = 0;
            newFieldMap.isReadOnly = false;

            this.selectedWorkflowOverride.fieldMappings.push(newFieldMap);

            this.save();
        }

        public addQueryGrid() {
            this.currentQueryGridOverride = this.mapConfigurationOverridesService.createQueryGridOverride();
            this.currentQueryGridOverride.queryGridConfiguration = this.selectedQueryGrid;
            this.currentQueryGridOverride.name = this.selectedQueryGrid.name;
            this.currentQueryGridOverride.excludeNullPlaceholders = true;
            this.currentQueryGridOverride.queryGridConfiguration.queryGridQueries.forEach(q => {
                if (q.esriQueryConfiguration) {
                    q.esriQueryConfiguration.wherePredicates.forEach(w => {
                        if (w.isPlaceholder) {
                            let placeholderValue = this.mapConfigurationOverridesService.createGisWherePlaceHolderValue();

                            placeholderValue.placeHolderUniqueIdentifier = w.placeHolderUniqueIdentifier;
                            placeholderValue.name = w.placeholderName;

                            this.currentQueryGridOverride.placeHolderValues.push(placeholderValue);
                        }
                    });
                }

                if (q.gisDatastoreQueryConfiguration) {
                    q.gisDatastoreQueryConfiguration.wherePredicates.forEach(w => {
                        if (w.isPlaceholder) {
                            let placeholderValue = this.mapConfigurationOverridesService.createGisWherePlaceHolderValue();

                            placeholderValue.placeHolderUniqueIdentifier = w.placeHolderUniqueIdentifier;
                            placeholderValue.name = w.placeholderName;

                            this.currentQueryGridOverride.placeHolderValues.push(placeholderValue);
                        }
                    });
                }
            });

            this.currentOverride.queryGridConfigurationOverrides.push(this.currentQueryGridOverride);
            this.save();
        }

        public setActionOverride(override:Wars.Domain.Model.Gis.GisActionWorkflowOverride) {
            this.selectedWorkflowOverride= override;
            var lastActionBlock = Enumerable.from(this.selectedWorkflowOverride.gisActionWorkflowConfiguration
                    .gisActionBlocks)
                .lastOrDefault();

            if (lastActionBlock.gisActionBlockType == Wars.Domain.Model.Codes.Enums.GisActionBlockType.AddFeature) {
                this.isLastActionAddFeature = true;
                this.metadataProperties = [];

                for (let i = 1; i < 21; i++) {
                    if (lastActionBlock.addFeaturesConfiguration.gisDatastore['metadata' + i + 'PropertyName']) {
                        this.metadataProperties.push({
                            name: lastActionBlock.addFeaturesConfiguration.gisDatastore['metadata' + i + 'PropertyName'],
                            index: i
                        });
                    }
                }
                console.log(this.metadataProperties);

            } else {
                this.isLastActionAddFeature =false; 
            }
        }

        public deleteQueryGridOverride() {
            this.deleteService.deleteWithModalConfirmIfNecessary("QueryGridOverride",
                this.currentQueryGridOverride.id, "QueryGridOverride", () => {
                    this.currentOverride.queryGridConfigurationOverrides.remove(this.currentQueryGridOverride);

                    this.currentQueryGridOverride = null;
                });
        }

        public save() {
            this.mapConfigurationOverridesService.saveAllChanges();
        }

        public currentQueryGridOverride: Wars.Domain.Model.Gis.QueryGridOverride;
        public selectedQueryGrid: Wars.Domain.Model.Gis.QueryGridConfiguration;
        currentIncludedFunction: Wars.Domain.Model.Gis.IncludedMapFunction;
    }
}